import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {IntersectRequestWithLayer} from './type';

export default {
    namespace: 'intersect',

    state: {},

    effects: (dispatch: any) => ({
        saveIntersect(data: IntersectRequestWithLayer) {
            return actionWrapper(
                 () => axios.post('intersect', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
    }),

    reducers: {},
};
